import * as React from "react";
import { Scale } from "lucide-react";
import { useTranslation } from "react-i18next";

const LegalNotice = () => {
  const { t } = useTranslation("common");

  return (
    <div className="border rounded border-tertiary my-6">
      <div className="container p-3">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8">
          <div className="flex items-center gap-2 text-secondary">
            <Scale className="w-5 h-5 flex-shrink-0" />
            <span className="font-semibold text-base">{t("legal.title")}</span>
          </div>
          <div className="flex-1 text-sm text-secondary leading-relaxed">
            <p>
              &copy; {new Date().getFullYear()} Victor Dibia. {t("legal.allRightsReserved")}{" "}
              {t("legal.inquiries")}{" "}
              <a
                href="mailto:support@multiagentbook.com"
                className="inline-flex items-center gap-1 text-accent hover:text-accent/80 underline font-medium"
              >
                support@multiagentbook.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalNotice;
